module.exports = __webpack_public_path__ + "img/icon_popover_arrow.b115531c.svg";